import { IRestaurantDetail, RestaurantList } from "../models/IRestaurantDetail";
import { IDiscountedFoodList } from "../models/IDiscountedFood";
import { configWithWebToken } from "./config";

export const getRestaurantList = async (townId?: string) => {
  const params: Record<string, string | number> = {
    pageIndex: 0,
    pageSize: 20,
  };
  if (townId) params.townId = townId;

  const res = await configWithWebToken.get<RestaurantList>(
    "Restourants/restourantList",
    { params }
  );
  res.data.items = res.data.items.filter((r) => r.restourantIsEnabled);
  return res;
};

export const getRestaurantById = (id: string) => {
  // Public uc: misafir kullanici da restoran detayini gorebilmeli.
  // configWithUserToken ile cagrilirsa token yokken istek hic gitmiyor.
  return configWithWebToken.get<IRestaurantDetail>(`Restourants/${id}`);
};

/**
 * Ana sayfa indirim şeridi. Anonim uç; sıralama (önce açık restoranlar, sonra en büyük
 * indirim) ve restoran başına en çok 3 ürün sınırı sunucuda uygulanır. Ürün yoksa
 * 404 değil, boş items döner.
 */
export const getDiscountedFoods = (townId?: string, pageIndex = 0, pageSize = 20) => {
  const params: Record<string, string | number> = { pageIndex, pageSize };
  if (townId) params.townId = townId;
  return configWithWebToken.get<IDiscountedFoodList>("Restourants/discounted-foods", { params });
};
